import { Box, Grid, Typography } from "@mui/material";
import { useContext } from "react";
import { OperatingManualStyleContext } from "../../../../../contexts/OperatingManualStyleContext";
import Image1 from "../../../../../assets/images/operating-manual/3/patient-dashboard.png";
import Image1French from "../../../../../assets/images/operating-manual/3/patient-dashboard-fr.png";
import { useTranslation } from "react-i18next";

const PatientPage = () => {
  const { sectionContainerStyle } = useContext(OperatingManualStyleContext);
  const { t } = useTranslation();

  const imgAttributes = [[Image1, Image1French]];

  return (
    <div>
      <Box sx={{ ...sectionContainerStyle, padding: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            background:
              "linear-gradient(102deg, #5d5cfe -17.62%, #996ad2 30.87%, #f18e8e 87.31%)",
            color: "white",
            p: 1,
            pl: 4,
            borderRadius: 2,
            mb: 3,
            boxShadow: "0px 0.625rem 3rem rgba(0, 0, 0, 0.06)",
          }}
        >
          <Typography id="patient-page" variant="h6" fontWeight="bold">
            {t(`operating_manual_portal_patient_header`)}
          </Typography>
        </Box>

        <div className="mx-auto max-w-4xl">
          <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="center"
          >
            {/* Patient Page Section */}
            <Grid item xs={12}>
              <Box
                component="img"
                src={imgAttributes[0][t("operating_manual_image_index")]}
                alt="Patient Dashboard"
                sx={{
                  width: "100%",
                  borderRadius: 1,
                  display: "block",
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                className="mx-auto mb-5 bg-gray-100 p-4 rounded-lg shadow-md"
              >
                {[...Array(4)].map((_, index) => (
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    key={index}
                    className="mb-4"
                  >
                    <Grid item xs={1}>
                      <Typography fontWeight="bold">{index + 1}</Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography fontWeight="bold">
                        {t(
                          `operating_manual_portal_patient_view_header${index + 1}_header`
                        )}
                      </Typography>
                      <Typography>
                        {t(
                          `operating_manual_portal_patient_view_content${index + 1}_content`
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Box>
    </div>
  );
};

export default PatientPage;
